import { useSelector } from 'react-redux';
import { getCartStatusData } from 'b2b-apps/core/cart/redux/cartStatus/selectors';
import { CartStatusType } from 'b2b-common/core/cart/api/CartTypes';

export const useCartStatusData = (): CartStatusType => useSelector(getCartStatusData);
